<div class="light-blue-border loading-box"><strong>{{compartment}}{{position}}</strong>{{ containerType === LoadingContainerType.CONTAINER ? side : 'P'}}
  <span [innerHTML]="formattedHTML"></span>
</div>
